// Func = limiting Scope for this file
(function(){

	function resizeWindow(){

	}
	function scrollDown(){
		let top = $(document).scrollTop();
		if (top > 0) {

		} else {

		}
	}

	$(document).ready(function () {

		//Call function with browser is resized.
		$(window).resize(function (event) {
			resizeWindow();
		});
		resizeWindow();

		//Acts when scroll down page.
		$(window).scroll(function (event) {
			scrollDown();
		});

		// Main Nav Dropdown
		$("#primary-nav li").hover(function(){
			$(this).addClass("hover");
			$('ul.submenu',this).fadeIn(200);
		}, function(){
			$(this).removeClass("hover");
			$('ul.submenu',this).fadeOut(200);
		});

		//Properties Day's Calendar [Enable/Disable,ClassName,Tooltip]
		let DATE_STYLE = [true];
		function calendarRange(date){
			let d1=$.datepicker.parseDate(DATE_FORMAT,$('#CheckIn').val());
			let d2=$.datepicker.parseDate(DATE_FORMAT,$('#CheckOut').val());
			if (d1 && date.getTime() == d1.getTime() || d2 && date.getTime() == d2.getTime()) {
				DATE_STYLE[1] = 'highlight-top';
			}else if(date > d1 && date < d2){
				DATE_STYLE[1] = 'highlight';
			}else{
				DATE_STYLE[1] = '';
			}
			return DATE_STYLE;
		}

		//Check in and check out datepicker for booking engine
		const DATE_FORMAT = ($("#CheckIn").data("format") !== undefined && $("#CheckIn").data("format")) ? $("#CheckIn").data("format") : "yy-mm-dd";
        $( "#CheckIn" ).datepicker({
			//showOn: "both",
			//buttonImage: SITE_FILES+"images/img-calendar-gray.png",
			//buttonImageOnly: true,
			changeMonth: true,
            dateFormat: DATE_FORMAT,
            numberOfMonths: 1,
			minDate: 0,
			beforeShowDay: (date) => calendarRange(date),
			onSelect: function( selectedDate ) {
				let getDate = $(this).datepicker('getDate');
				let newDate = new Date(getDate.getTime());
				newDate.setDate(newDate.getDate() + 3);
				$( "#CheckOut" ).datepicker( "setDate", newDate );
				$( "#CheckOut" ).datepicker( "option", "minDate", selectedDate );
			}
		});
		$( "#CheckOut" ).datepicker({
			//showOn: "both",
			//buttonImage: SITE_FILES+"images/img-calendar-gray.png",
			//buttonImageOnly: true,
            dateFormat: DATE_FORMAT,
            changeMonth: true,
			numberOfMonths: 1,
			beforeShowDay: (date) => calendarRange(date),
			onSelect: function( selectedDate ) {
				//$( "#CheckIn" ).datepicker( "option", "maxDate", selectedDate );
			}
		});

		let datePicker = document.querySelector('.ui-datepicker');
		// datePicker.classList.add('ui-datepicker-inline');

		// Map: Return to previous page button. Change body id to match map template's name.
		//$('body#map-category-sidebar #content').prepend('<a class="btn return-from-map" href="javascript:history.back()">« Back to previous page</a>');

		//Header scroll behavior
		const headerScrolling = (topStart, scrollClass, hideClass) => {
			let header = document.querySelector('.js-header');
			let lastScrollTop = 0;
			if(pageYOffset > topStart){
				header.classList.add('load-hide');
			}
			window.addEventListener('scroll',_=>{
				if(header != null){
					header.classList.remove('load-hide');
					if(pageYOffset > topStart){
						header.classList.add(hideClass);
						if(pageYOffset > lastScrollTop){
							header.classList.add(scrollClass);
						}else{
							header.classList.remove(scrollClass)
						}
					}else{
						header.classList.remove(hideClass);
					}
					lastScrollTop = pageYOffset <= 0 ? 0 : pageYOffset;
				}

			}, false);
		};
		headerScrolling(50, 'scrolled', 'colored');

		//Parallax effect on scroll
		const parallaxImage = (parallaxElement, direction = true)=> {
			let images = document.querySelector(parallaxElement);
			if(images != null){
				let parallax = images.getAttribute('data-parallax');
				window.addEventListener('scroll', _=>{
					if(direction){
						if(pageYOffset < window.outerHeight){
							images.setAttribute('style', `transform: translateY(${pageYOffset/parallax}px)`);
						}
					}else{
						let startFrom = document.body.scrollHeight - (window.outerHeight * 1.4);
						if(pageYOffset > (startFrom)){
							images.setAttribute('style', `transform: translateY(${(pageYOffset-startFrom)/parallax}px)`);
						}
					}
				})
			}
		};
		parallaxImage('.js-parallax-image');
		parallaxImage('.js-footer-parallax', false);

		//Auto Scroll on button Click
		const onClickScroll = (triggerClass, targetClass) => {
			let trigger = document.querySelector(triggerClass);
			let target = document.querySelector(targetClass);
			if(trigger !== null && target !== null){
				trigger.addEventListener('click', _=>{
					target.scrollIntoView();
				})
			}
		};
		onClickScroll('.js-auto-scroll-trigger','.js-auto-scroll-target');

		//Add a class to each element when scroll through it
		const scrollAnimate = ( targetElement , classAdded, animStart, delay) => {
			let top = 0;
			let doc = document.documentElement;
			let targetElements = document.querySelectorAll(targetElement);
			let	startHeight = document.documentElement.clientHeight / animStart;
			targetElements.forEach(e => {
				let eachTop = e.getBoundingClientRect().top;
				window.addEventListener('scroll', _=>{
					top = ((window.pageYOffset || doc.scrollTop) - (doc.clientTop || 0)) + startHeight;
					if(top > eachTop && !e.classList.contains(classAdded)) {
						setTimeout(_=>{e.classList.add(classAdded);},delay)
					}
				});
			});
		};
		scrollAnimate('.js-image-target1', 'image-shown', '2','0');
		scrollAnimate('.js-image-target2', 'image-shown', '2','400');
		scrollAnimate('.js-image-target3', 'bg-shown', '2','0');

	});

	$(window).on('load', function() {

		
	});

	function addClassOnScroll ( elementClass, classAdded ){
		window.addEventListener('scroll',()=>{
			let header = document.querySelector(elementClass);
			if(header != null){
				if(pageYOffset > 100){
					header.classList.add(classAdded)
				}else{
					header.classList.remove(classAdded)
				}
			}
		});
	}

	addClassOnScroll('.js-header', 'scrolled');


	function addClassOnClick ( targetElementClass, triggerElementClass, classToAdd ) {
		let targetElement = document.querySelector(targetElementClass);
		let triggerElement = document.querySelector(triggerElementClass);
		triggerElement.addEventListener('click', _=>{
			targetElement.classList.toggle(classToAdd);
			triggerElement.classList.toggle(classToAdd);
		})
	}

	addClassOnClick('.js-menu-target', '.js-menu-trigger', 'open');

	function changeTextOnClick ( targetElementClass, oldContent, newContent ) {
		let elementToChange = document.querySelector(targetElementClass);
		let elementSpan = elementToChange.querySelector('span');
		elementToChange.addEventListener('click', _=>{
			if (elementSpan.innerHTML === oldContent) {
				elementSpan.innerHTML = newContent;
			} else {
				elementSpan.innerHTML = oldContent;
			}
		})
	}

	changeTextOnClick('.js-menu-trigger', 'Menu', 'Close');
	function menu(){
		let item_menu = document.querySelector('.primary-nav-5 > a');
		let submenu = document.querySelector('.primary-nav-5 .submenu');
		item_menu.addEventListener('click', event =>{
			let windowWidth = window.screen.width;
			if(windowWidth >= 768 || windowWidth <= 1024){
				event.preventDefault();
				submenu.removeAttribute('style');
				submenu.classList.toggle('sub-menu-active');
			}
		})
	};
	//menu();

	let last_item_menu = document.querySelector('.primary-nav-4 > a');
	last_item_menu.removeAttribute("href");


}());